export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";